import { createBrowserHistory } from 'history'
import { Config } from '../config'

export const history = createBrowserHistory({
  basename: Config.basePath
})
